/**
 * Client-safe locale constants. Kept in a separate file from i18n.ts
 * because that one imports next/headers (server-only) for cookie
 * reads, and we need these constants in client components too (the
 * language/currency picker modal).
 */

export const LOCALES = ["en", "el", "de", "fr", "it"] as const;
export type Locale = (typeof LOCALES)[number];

export const LOCALE_LABELS: Record<Locale, string> = {
  en: "English",
  el: "Ελληνικά",
  de: "Deutsch",
  fr: "Français",
  it: "Italiano",
};
